/**
 * The player's mechanics as plugins - see README.md (backend services/game_builder/mechanics/) for
 * how to add one. Each export is a registry (registry.js); MissionGame, simEngine and the scene
 * arranger read them and list nothing about a mechanic themselves.
 */
import { COMPARES, EFFECTS, REACTIONS, SHOWN_PROPS } from './engine';
import { CONTROLS, INTERACTIONS } from './interactions';
import { CLOSEUPS, KINDS, MARKS } from './kinds';
import { RELATIONS } from './relations';

export { COMPARES, EFFECTS, REACTIONS, SHOWN_PROPS } from './engine';
export { CONTROLS, INTERACTIONS, controlOf, howTo, howToAct, nudge } from './interactions';
export { CLOSEUPS, Captioned, Dial, HoldButton, ItemExtras, KINDS, MARKS, badgesFor, shownName } from './kinds';
export { RELATIONS, relationOf } from './relations';
export { createRegistry } from './registry';

/** Every plugin's version, by registry. */
export const versions = () => Object.fromEntries(Object.entries({
  compares: COMPARES, effects: EFFECTS, reactions: REACTIONS, shown_props: SHOWN_PROPS, interactions: INTERACTIONS, controls: CONTROLS,
  kinds: KINDS, marks: MARKS, closeups: CLOSEUPS, relations: RELATIONS
}).map(([name, reg]) => [name, reg.versions()]));
